import { render } from "./Prikaz511.vue?vue&type=template&id=1f361e77"
import script from "./Prikaz511.vue?vue&type=script&lang=js"
export * from "./Prikaz511.vue?vue&type=script&lang=js"

import "./Prikaz511.vue?vue&type=style&index=0&id=1f361e77&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__